/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 * 
**/


export default function useMenus() {
    
    
    return {
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Home",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/quickbookingwidget",
    "label": "Quick Booking",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookingquick",
    "label": "Book Now",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/paymentdue",
    "label": "Pay Due Online",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookingpromotions",
    "label": "Booking Promotions",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookings",
    "label": "Bookings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookings/listcustomer",
    "label": "My Bookings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/partnershops/add",
    "label": "My Shop Config",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/topupwallet",
    "label": "Topup Wallet",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/partnershops/partner",
    "label": "My Shops",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookingpartnervw",
    "label": "Shop Bookings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bookingstatushistory",
    "label": "Booking Status History",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/inventory",
    "label": "Inventory",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/notifications",
    "label": "Notifications",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/orderitems",
    "label": "Orderitems",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/payments",
    "label": "Payments",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/partnerpaymentvw",
    "label": "Customer Payments",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/promotions",
    "label": "Promotions",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/serviceprices",
    "label": "Serviceprices",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/services",
    "label": "Services",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/partnershops",
    "label": "Shop",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/category",
    "label": "Category",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/itemtypes",
    "label": "Item Types",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/settings",
    "label": "Settings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/staff",
    "label": "Staff",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/staffvw",
    "label": "My Staff",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/staffassignments",
    "label": "Staff Assignments",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwactivebookings",
    "label": "Active bookings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwcustomerlifetimevalue",
    "label": "Customer lifetime value",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwdailybookingsummary",
    "label": "Daily booking summary",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwinventorystatus",
    "label": "Inventory status",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwmonthlyperformance",
    "label": "Monthly Performance",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwpendingpayments",
    "label": "Pending Payments",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwserviceperformance",
    "label": "Service Performance",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vwstaffperformance",
    "label": "Staff Performance",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/payments/paymentcustomer",
    "label": "Payment History",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/orderitems/listordcustomer",
    "label": "My Ordered Items",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/users",
    "label": "Users",
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/permissions",
    "label": "Permission",
    "icon": "pi pi-user-edit",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/additems",
    "label": "Add Items Bookings",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/billsummaryvw/partner",
    "label": "Bill Summary",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/bcalender",
    "label": "Booking Calendar",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/partnerreviews/add",
    "label": "Customer Review",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/staffcalendar",
    "label": "BookingCalendar",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/printinvoice",
    "label": "Print Invoice",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/customerreview",
    "label": "Customer Review",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  }
],
	isactive: [    
{value: "0", label: "0"},
	{value: "1", label: "1"}
    ],
	rating: [    
{value: "5", label: "⭐⭐⭐⭐⭐ Excellent"},
	{value: "4", label: "⭐⭐⭐⭐Very Good"},
	{value: "3", label: "⭐⭐⭐Good"},
	{value: "2", label: "⭐⭐Fair"},
	{value: "1", label: "⭐Poor"}
    ],
	discounttype: [    
{value: "FLAT", label: "Flat"},
	{value: "PERCENT", label: "Percent"}
    ],
	assignmenttype: [{"label":"Pickup","value":"pickup"},{"label":"Deivery","value":"deivery"}],
        exportFormats: {
            print: {
                label: 'Print',
                icon: 'pi pi-print',
                type: 'print',
                ext: '',
            },
            pdf: {
                label: 'Pdf',
                icon: 'pi pi-file-pdf',
                type: 'pdf',
                ext: 'pdf',
            },
            excel: {
                label: 'Excel',
                icon: 'pi pi-file-excel',
                type: 'excel',
                ext: 'xlsx',
            },
            csv: {
                label: 'Csv',
                icon: 'pi pi-table',
                type: 'csv',
                ext: 'csv',
            },
        },
    }
}